export class GetLensCertificateLabelInput {
    orderIds: number[];
}